// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrincipalGrant
 */
export interface PrincipalGrant {
    /**
     * 
     * @type {string}
     * @memberof PrincipalGrant
     */
    capability_set: string;
    /**
     * 
     * @type {string}
     * @memberof PrincipalGrant
     */
    granted_at: string;
    /**
     * 
     * @type {string}
     * @memberof PrincipalGrant
     */
    granted_by: string;
    /**
     * 
     * @type {string}
     * @memberof PrincipalGrant
     */
    resource_id: string;
    /**
     * 
     * @type {string}
     * @memberof PrincipalGrant
     */
    resource_type: string;
}

/**
 * Check if a given object implements the PrincipalGrant interface.
 */
export function instanceOfPrincipalGrant(value: object): value is PrincipalGrant {
    if (!('capability_set' in value) || value['capability_set'] === undefined) return false;
    if (!('granted_at' in value) || value['granted_at'] === undefined) return false;
    if (!('granted_by' in value) || value['granted_by'] === undefined) return false;
    if (!('resource_id' in value) || value['resource_id'] === undefined) return false;
    if (!('resource_type' in value) || value['resource_type'] === undefined) return false;
    return true;
}

export function PrincipalGrantFromJSON(json: any): PrincipalGrant {
    return PrincipalGrantFromJSONTyped(json, false);
}

export function PrincipalGrantFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrincipalGrant {
    if (json == null) {
        return json;
    }
    return {
        
        'capability_set': json['capability_set'],
        'granted_at': json['granted_at'],
        'granted_by': json['granted_by'],
        'resource_id': json['resource_id'],
        'resource_type': json['resource_type'],
    };
}

export function PrincipalGrantToJSON(json: any): PrincipalGrant {
    return PrincipalGrantToJSONTyped(json, false);
}

export function PrincipalGrantToJSONTyped(value?: PrincipalGrant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capability_set': value['capability_set'],
        'granted_at': value['granted_at'],
        'granted_by': value['granted_by'],
        'resource_id': value['resource_id'],
        'resource_type': value['resource_type'],
    };
}
